import {
  Classes,
  Dialog,
  HTMLTable,
  InputGroup,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { EanStore } from "../../stores/legislacao/EanStore";
import { AppStore } from "../../stores/AppStore";
import { Pager } from "../utils/Pager";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import LoadingModal from "../loading/LoadingModal";

var debounce = require('lodash.debounce');

interface EansPageProps {
}

interface EansPageState {
}

@observer
export class EansPage extends React.Component<EansPageProps, EansPageState> {
  obs = observable({
    adding: false as boolean,
    fetchOptions: {} as any
  })

  constructor(props: EansPageProps) {
    super(props);

    this.obs.fetchOptions = debounce(this.handldeFilterEans.bind(this), 800);

  }

  async componentDidMount() {
    AppStore.setTitle("EANs");

    EanStore.obs.filter = ""
    EanStore.obs.currentPage = 1

    await EanStore.handldeFilterEans(EanStore.obs.filter, EanStore.obs.currentPage)

  }

  handlePageChange = async (page: number) => {

    EanStore.obs.currentPage = page

    await EanStore.handldeFilterEans(EanStore.obs.filter, page)

  };

  async handldeFilterEans() {

    EanStore.obs.currentPage = 1

    await EanStore.handldeFilterEans(EanStore.obs.filter, EanStore.obs.currentPage)

  }

  render() {

    let items = EanStore.obs.eans_paginate?.map((ean) => {
      return (
        <tr key={ean.id}>
          <td>{ean.ean}</td>
          <td>{ean.produto}</td>
          <td>{ean.cest}</td>
          <td>{ean.ncm}</td>
          <td />
        </tr>
      );
    });

    return (
      <><div>
        <MDBRow>
          <MDBCol md="6" className="inputFilter">
            <InputGroup
              round
              leftIcon="search"
              style={{ width: 600, borderRadius: 10 }}
              placeholder="Filtrar..."
              onChange={(e: any) => {
                EanStore.obs.filter = e.target.value
                this.obs.fetchOptions()
              }}
              value={EanStore.obs.filter} />
          </MDBCol>
        </MDBRow>

        <div className="TableDefault">
          <HTMLTable
            className="table table-hover dataTable"
            style={{ width: "100%" }}
            small
          >
            <thead>
              <tr>
                <th style={{ width: 150 }}>EAN</th>
                <th>Produto</th>
                <th style={{ width: 150 }}>CEST</th>
                <th style={{ width: 150 }}>NCM</th>
                <th style={{ width: 20 }} />
              </tr>
            </thead>
            <tbody>
              {items}
            </tbody>
          </HTMLTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={EanStore.obs.currentPage}
            totalCount={EanStore.obs.totalRows}
            pageSize={50}
            onPageChange={this.handlePageChange} />
        </div>
      </div>

      <LoadingModal open={EanStore.obs.loading_eans} onClose={() => EanStore.obs.loading_eans = false} title={"Buscando"} />

      </>
    );
  }
}

export default EansPage;
